/**
 * Integrations feature API layer — OpenAPI-first (§9.1, §9.3).
 *
 * Integrations list, get, update, test.
 */
import {
  getAdminIntegrationsListQueryKey,
  useAdminIntegrationsGet as useGenGet,
  useAdminIntegrationsList as useGenList,
  useIntegrationTest as useGenTest,
  useAdminIntegrationsUpdate as useGenUpdate,
} from "@shared/api/generated/admin/admin";
import { useQueryClient } from "@tanstack/react-query";

export type {
  DirectoryIntegration,
  IntegrationTestResponse,
} from "@shared/api/generated/model";

// ── Queries ─────────────────────────────────────────────────────────────────

export const useIntegrations = () => useGenList({ query: { staleTime: 60_000 } });

export const useIntegration = (slug?: string) => {
  const enabled = Boolean(slug);
  return useGenGet(slug ?? "", { query: { enabled, staleTime: 60_000 } });
};

// ── Mutations ───────────────────────────────────────────────────────────────

export const useUpdateIntegration = () => {
  const qc = useQueryClient();
  return useGenUpdate({
    mutation: {
      onSuccess: () => {
        qc.invalidateQueries({ queryKey: getAdminIntegrationsListQueryKey() });
      },
    },
  });
};

export const useIntegrationTest = () => useGenTest();
